import { __rest } from "tslib";
import * as React from 'react';
import { getInitials } from './helpers';
import { StyledAvatar } from './Avatar.styled';
export const Avatar = (_a) => {
    var { size = 'regular', text } = _a, otherProps = __rest(_a, ["size", "text"]);
    return (React.createElement(StyledAvatar, Object.assign({ size: size }, otherProps), getInitials(text)));
};
//# sourceMappingURL=Avatar.js.map